import PropTypes from "prop-types";

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

function NavigationBoxList({ className, children }) {
  return (
    <div className={className ? className : undefined}>
      <div className="flex flex-col gap-y-4">{children}</div>
    </div>
  );
}

NavigationBoxList.propTypes = propTypes;
export default NavigationBoxList;
